export const BUILD_NUMBER=0
export const BUILD_DATE=''